import { Badge, Button, Tooltip } from 'antd'
import { PermissionsGate } from 'features/permissions'
import { FileDiff } from 'lucide-react'
import { FC, useState } from 'react'
import { PERMISSION_GECKO_INTERNAL_MEMBER, PERMISSION_MODUS } from 'types'

import { FfsAssetModelDiffDrawer } from './FfsAssetModelDiffDrawer'
import { useFfsAssetModelDiff } from './useFfsAssetModelDiff'

/**
 * Gecko-internal only: icon button that opens the FFS asset-model diff
 * drawer (ticket snapshot vs the unit's live master asset model). Mirrors
 * `LlmDiffLauncher`'s placement/gating pattern in `LibraView`'s header.
 *
 * `useFfsAssetModelDiff` is called before the permissions gate so the
 * `canDiff` short-circuit (hide entirely on non-asset-scoped or unsnapshotted
 * tickets) applies for everyone -- its queries are SWR-deduped against data
 * the asset-model step already loaded, so this adds no extra fetch.
 */
export const FfsAssetModelDiffLauncher: FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { canDiff, changeCount } = useFfsAssetModelDiff()

  if (!canDiff) return null

  return (
    <PermissionsGate
      requires={[PERMISSION_GECKO_INTERNAL_MEMBER, PERMISSION_MODUS]}>
      <Tooltip title='Asset model changes'>
        <Badge count={changeCount} size='small' offset={[-2, 4]}>
          <Button type='text' onClick={() => setIsOpen(true)}>
            <FileDiff size={16} />
          </Button>
        </Badge>
      </Tooltip>
      {isOpen && <FfsAssetModelDiffDrawer onClose={() => setIsOpen(false)} />}
    </PermissionsGate>
  )
}
